import { Box, Typography } from '@mui/material';

export const SystemAnalyticsPage = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        System Analytics
      </Typography>
      <Typography color="text.secondary">
        Usage analytics and reports coming soon...
      </Typography>
    </Box>
  );
};
